import type { AdminLogEntry, AdminLogLevel } from "@/server/admin/logEntries";
import { resolveLogDetails } from "@/server/admin/logEntries";

export const levelColor: Record<AdminLogLevel, string> = {
  DEBUG: "var(--log-debug)",
  INFO: "var(--log-info)",
  WARN: "#f97316",
  ERROR: "var(--log-error)",
};

export const formatLogTime = (ts: string) => {
  const date = new Date(ts);

  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).replace(",", "");
};

export const formatLogEntryJson = (entry: AdminLogEntry) => {
  const payload: Record<string, unknown> = {
    time: entry.ts,
    level: entry.level,
    message: entry.message,
  };

  if (entry.runId) {
    payload.runId = entry.runId;
  }

  if (entry.phone) {
    payload.phone = entry.phone;
  }

  const details = resolveLogDetails(entry);

  if (details) {
    payload.details = details;
  }

  return JSON.stringify(payload, null, 2);
};
